import { makeStyles } from "@mui/styles";

export default makeStyles((theme) => ({
  innerHeadingLeft: {
    margin: "10px",
    marginBottom: "20px",
    display: "flex",
    alignItems: "center",
    marginLeft: "5px",
    [theme.breakpoints.down("md")]: {
      marginBottom: "10px"
    },
    [theme.breakpoints.down("sm")]: {
      marginBottom: "15px"
    },
    "& img,svg": {
      marginRight: "0.400rem",
      width: "1.25rem",
      [theme.breakpoints.down("md")]: {
        width: "0.938rem"
      }
    },
    "& .MuiTypography-h6": {
      margin: "0",
      color: theme?.palette?.primaryText?.[100],
      fontFamily: "Poppins",
      fontSize: "1.25rem",
      fontStyle: "normal",
      fontWeight: 700,
      lineHeight: "normal",
      display: "flex",
      alignItems: "center",
      [theme.breakpoints.down("md")]: {
        fontSize: "0.85rem"
      },
      [theme.breakpoints.down("sm")]: {
        fontSize: "0.85rem",
        textOverflow: "ellipsis",
        overflow: "hidden",
        maxWidth: "190px",
        whiteSpace: "nowrap",
        display: "block"
      }
    }
  },
  heartIcon: {
    width: "25px !important",
    height: "25px"
  },
  arrowbutton: {
    position: "absolute",
    top: "-35px",
    right: "30px !important",
    transform: "translate(-50%, -50%)",
    "& button": {
      borderRadius: "10px",
      background: theme?.palette?.primaryBG?.[400],
      minWidth: "38px",
      padding: "8px 8px",
      [theme.breakpoints.down("sm")]: {
        minWidth: "28px"
      },
      "&:hover": {
        borderRadius: "10px",
        background: theme?.palette?.primaryBG?.[400],
        padding: "13px 8px"
      },
      "& svg": {
        "&.active": {
          color: theme?.palette?.primary2TextColor?.main
        },
        "&.inactive": {
          color: theme?.palette?.primary2TextColor?.main,
          opacity: "0.4"
        }
      }
    },
    [theme.breakpoints.down("sm")]: {
      top: "-20px"
    }
  },
  leftArrow: {
    right: "30px !important",
    [theme.breakpoints.down("sm")]: {
      right: "30px !important"
    }
  },
  rightArrow: {
    right: "-20px !important",
    [theme.breakpoints.down("sm")]: {
      right: "-10px !important"
    }
  },
  frvbtnstyle: {},
  prvbtnstyle: {}
}));
